import { theme } from '@theme';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export type RightModalProps = {
  enable: boolean;
  enableReset: boolean;
  resetButtonAction: () => void;
  hideFilter: () => void;
  children?: ReactNode;
};

const RightModalLayout: FC<RightModalProps> = (props) => {
  return (
    <RightLayoutDiv data-testid='right-container' className={`${props.enable ? 'slide' : ''}`}>
      {props.enable && (
        <>
          <HeaderArea data-testid='header-container'>
            <CloseButton data-testid='close-button' onClick={props.hideFilter}>
              <CloseLeftArrow className='am-icon am-icon-angle-left'></CloseLeftArrow>
            </CloseButton>
            <Header data-testid='header'>Filters</Header>
            <ResetHeader onClick={props.resetButtonAction} enableReset={props.enableReset}>
              Reset
            </ResetHeader>
          </HeaderArea>
          <FilterArea>{props.children}</FilterArea>
          <ShowResultsButton onClick={props.hideFilter}>Show Results</ShowResultsButton>
        </>
      )}
    </RightLayoutDiv>
  );
};

export default RightModalLayout;

const RightLayoutDiv = styled.div`
  width: 0;
  z-index: 200 !important;
  background: ${theme.palette.gray};
  overflow: auto;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  transition: 0.3s;
  &&.slide {
    width: 100%;
  }
  .select-all[type='checkbox']:indeterminate::before {
    width: 15px;
    height: 15px;
  }
`;

const CloseButton = styled.button`
  font-weight: ${theme.typography.fontWeights.bold};
  margin: 5px;
  float: left;
  width: 40px;
  background: ${theme.palette.white};
  border-radius: 5px;
  border: 1px solid ${theme.palette.backgroundGray};
  padding: 0 5px;
`;

const CloseLeftArrow = styled.span`
  font-size: 120%;
  color: ${theme.palette.black} !important;
`;

const Header = styled.div`
  font-size: large;
  margin: 5px;
  float: left;
  font-weight: ${theme.typography.fontWeights.bold};
`;

type ResetHeaderProps = {
  enableReset: boolean;
};

const ResetHeader = styled.div<ResetHeaderProps>`
  font-size: large;
  margin: 5px;
  float: left;
  font-weight: ${theme.typography.fontWeights.bold};
  color: ${theme.palette.blue};
  ${(props) => (!props.enableReset ? `opacity: .5; pointer-events: none;` : ``)};
`;

const HeaderArea = styled.div`
  display: flex;
  padding: 5%;
  justify-content: space-between;
`;

const FilterArea = styled.div`
  margin: 0 5%;
`;

const ShowResultsButton = styled.button`
  width: 90%;
  margin: 2% 5% 5% 5%;
  color: ${theme.palette.white};
  background-color: ${theme.palette.rebeccaPurple};
  border-radius: 5px;
  font-size: medium;
  padding: 5px;
`;
